import { FC, useEffect, useState } from "react";
import { useApiGet } from "../../../../../../hooks";
import { isAPITotallyComplete } from "../../../../../../utilities/apiFunctions";
import { ConfigurationNewPaymentDto } from "../../../../../../dtos/configuration-new-payment-dto";
import { FormPaymentWrapperProps } from "./TypesAddPayment";
import { defaultPaymentData } from "./ModalAddPaymentUtil";
import { useRecoilValue } from "recoil";
import { DefaultPaymentDateAtom } from "../../../BillingAtoms";
import FormPaymentAndBalanceTable from "./FormPaymentAndBalanceTable";
import { BillingPaymentPage } from "../../../../../../dtos/billing-payment-page";
import { conditionHasValue } from "../../../../../../utilities/conditionalSupportFunctions";
import { BaseTable } from "../../../../../../dtos/base-table";
const FormPaymentAndBalanceTableWrapper: FC<FormPaymentWrapperProps> = ({
  insuredId,
  paymentData,
  setPaymentData,
  errorMessages,
  accountTableData,
  readOnly = false,
  billingPaymentId = null,
}) => {
  const defaultPaymentDateAtomValue = useRecoilValue(DefaultPaymentDateAtom);
  const [paymentFormSelectsData, setPaymentFormSelectsData] =
    useState<ConfigurationNewPaymentDto | null>(null);
  const [paymentAccountTable, setPaymentAccountTable] = useState<
    BaseTable | undefined | null
  >(null);
  const { responseGet: responseGetConfig, dispatchGet: dispatchGetConfig } =
    useApiGet<any>(`api/PaymentActivity/GetConfigurationNewPayment`);
  const { responseGet: responseGetPayment, dispatchGet: dispatchGetPayment } =
    useApiGet<BillingPaymentPage>(
      `api/PaymentActivity/GetPaymentInformation?billingPaymentId=${billingPaymentId}`
    );

  useEffect(() => {
    if (!conditionHasValue(billingPaymentId)) dispatchGetConfig();
    else dispatchGetPayment();
  }, []);

  const setPaymentConfigurations = (responseConfiguration) => {
    if (isAPITotallyComplete(responseConfiguration)) {
      setPaymentData?.({
        ...paymentData,
        payment: defaultPaymentData(
          insuredId,
          responseConfiguration?.responseData?.defaultBankId,
          defaultPaymentDateAtomValue ?? new Date()
        ),
      });
      setPaymentAccountTable(accountTableData?.tableData);
      setPaymentFormSelectsData(responseConfiguration?.responseData ?? []);
    }
  };

  const setPaymentConfigurationsForEdit = (
    responsePayment?: BillingPaymentPage
  ) => {
    setPaymentData?.({
      ...paymentData,
      payment: responsePayment?.payment,
    });
    setPaymentAccountTable(responsePayment?.accountTable ?? undefined);
    setPaymentFormSelectsData(responsePayment?.configurationPayment ?? null);
  };

  useEffect(() => {
    setPaymentConfigurations(responseGetConfig);
  }, [responseGetConfig]);

  useEffect(() => {
    if (isAPITotallyComplete(responseGetPayment))
      setPaymentConfigurationsForEdit(
        responseGetPayment?.responseData ?? undefined
      );
  }, [responseGetPayment]);

  return (
    <>
      {paymentFormSelectsData !== null && (
        <FormPaymentAndBalanceTable
          paymentData={paymentData?.payment}
          setPaymentData={(payment) =>
            setPaymentData?.({ ...paymentData, payment: payment })
          }
          paymentFormSelectsData={paymentFormSelectsData ?? null}
          errorMessages={errorMessages}
          insuredId={insuredId}
          setBillingTransactionData={(billingTransactions) =>
            setPaymentData?.({
              ...paymentData,
              billingTransactionDataList: billingTransactions,
            })
          }
          accountTableData={{
            paymentProcessorFunction:
              accountTableData?.paymentProcessorFunction,
            tableData: paymentAccountTable,
          }}
          modalType={billingPaymentId ? "editPayment" : "newPayment"}
          readOnly={readOnly}
        />
      )}
    </>
  );
};

export default FormPaymentAndBalanceTableWrapper;
